

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';
import { EnumPaymentRequestStatuses } from './../enums';
import { EnumPaymentRequestTypes } from './../enums';
export class PaymentRequestListParams extends BaseEntity
{   
    public CustomerID: number; 
    public ContactPersonID: number; 
    public Statuses: EnumPaymentRequestStatuses[]; 
    public DateFrom: Date; 
    public DateTo: Date; 
    public SumFrom: number; 
    public SumTo: number; 
    public Types: EnumPaymentRequestTypes[]; 
	
}



